<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="iscompanyQuit"><img src="../../../assets/images/new/blueInfo.png" alt="">只可以对有出入库记录的产品或耗材进行盘点，需将产品录入库存系统再进行管理</div>
        <p class="order-title-boxs"><span class="blueBlock"></span><i>盘点信息</i></p>
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            label-width="140px"
            label-position="left"
          >
                <el-form-item
                  class="el-form-item-add ml20"
                  ref="name"
                  label="盘点名称："
                  prop="name"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.name" placeholder="请输入" class="width200"></el-input>
                </el-form-item>
                <el-form-item
                  class="el-form-item-add ml20"
                  ref="beginTime"
                  label="开始时间"
                  prop="beginTime"
                >
                  {{ form.beginTime }}
                </el-form-item>
                <el-form-item
                  class="el-form-item-add ml20"
                  ref="endTime"
                  label="结束时间"
                  prop="endTime"
                >
                  <el-date-picker
                    v-model="form.endTime"
                    type="datetime"
                    placeholder="选择日期"
                    @change="checkTime('end')"
                    :clearable="false"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item class="el-form-item-add ml20" label="盘点类型" prop="checkType" :rules="$rules.required">
                  <el-radio-group v-model="form.checkType" @change="changeRadio">
                    <el-radio label="whole">全部盘点</el-radio>
                    <el-radio label="part">部分盘点</el-radio>
                  </el-radio-group>
                </el-form-item>
          </el-form>
        </div>

        <div class="align-items">
          <p class="order-title-boxs">
            <span class="blueBlock"></span><i>选择盘点产品</i>
          </p>
          <div v-if="isChangeRadio">
            <span class="jishi fontSize16 pr16 cur" @click="seletGift" v-if="form.checkType=='part'">选择产品</span>
            <span class="fontSize16 pr16 cur" v-else>已选择全部产品</span>
          </div>
        </div>
        <div class="contents-body" v-if="itemList.length != 0">
          <el-row class="tables-title">
            <el-col :span="22" class="titles pl10">商品名称</el-col>
            <el-col :span="2" class="titles center">操作</el-col>
          </el-row>
          <div class="tables p30 scroll-auto">
            <div class="boxs" v-for="(item, index) in itemList" :key="index">
              <el-row>
                <el-col :span="22" class="color111 pl10">{{ item.productName }}</el-col>
                <el-col :span="2" class="detail right">
                  <i
                    class="el-icon-delete delete"
                    @click="deleteListSelected(item, index)"
                  ></i>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <div class="drawer-footer pr24 pb10">
          <div class="btns">
            <el-button type="primary" class="small-btn" @click="onSubmit">创建完成</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <selectGift ref="selectGift" @changeGift="giftCallback"></selectGift>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import imgUpload from "../../../components/common/modules/upload";
import selectGift from "./selectGift.vue";
export default {
  mixins: [minxin],
  components: { drawer, imgUpload, selectGift },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      form: {
          name: '',
          productBoList: [],
          beginTime: '',
          endTime: '',
          checkType: ''
        },
      oldAmount: '',
      isChangeRadio: false,
      selectList: [],
      selectConsumeList: [],
      itemList: [],
      type: '',
    };
  },
  created() {
    this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditTitle = "新建盘点";
        this.addEditShow = true;
        this.form.beginTime = this.formatDay(new Date());
      });
  },
  methods: {
    back() {
      this.$refs["form"].resetFields()
      this.addEditShow = false;
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    deleteListSelected(item, index) {
      // item.itemNum = Number(1);
      this.itemList.splice(index, 1);
    },
    checkTime (type) {
      this.type = type;

      let date1 = new Date().getTime();
        let date2 = this.form.endTime.getTime();
        if (date2 - date1 < 7140000) {
          this.$message.error("结束时间不能晚于当前的两个小时");
          this.form.endTime = '';
          return false;
        } else {
          
        }
    },
    changeRadio(value) {
      this.isChangeRadio = true;
      if (value == 'whole') {
          this.itemList = [];
          this.form.productBoList = [];
          sessionStorage.removeItem('selectItem');
        }
    },
    seletGift() {
      // 选择赠品
      this.$refs["selectGift"].$emit("set", {'selectList':this.selectList,'selectConsumeList':this.selectConsumeList});
    },
    giftCallback(org) {
      // 选择赠品回调函数
      console.log('选择回调后数据：',org);
      if (org) {
        this.selectList = org.selectList;
        this.selectConsumeList = org.selectConsumeList;
        let arr = [];
        arr = arr.concat(org.selectList,org.selectConsumeList);
        this.itemList = arr;
      };
    },
    inputChange (item) {
      // if (item.itemNum > item.inventoryNum) {
      //   return this.$message.error("不能大于库存数据");
      // }
      if (item.itemNum == '') {
        return;
      }
      if (item.itemNum > item.inventoryNum) {
        item.itemNum = this.oldAmount;
        this.$message.error("不能大于库存数据");
        return false;
      } else {
        this.oldAmount = item.itemNum;
      }
    },
    inputFocus (item) {
      this.oldAmount = item.itemNum;
    },
    onSubmit(values) {
        if (!this.form.name) {
          this.$message.error("盘点名称不能为空");
          return false;
        }
        if (!this.form.endTime) {
          this.$message.error("结束时间不能为空");
          return false;
        }
        if (!this.form.checkType) {
          this.$message.error("请选择盘点类型");
          return false;
        }
        if (this.form.checkType == 'part' && this.itemList.length == 0) {
          this.$message.error("请选择盘点产品");
          return false;
      }
      this.itemList.map(item => {
        item.productId = item.id;
      })
        this.form.productBoList = this.itemList;
        // this.form.beginTime = this.formatDate(this.form.beginTime);
        // this.form.beginTime = this.formatDate(new Date());
        this.form.endTime = this.formatDate(this.form.endTime);
        this.$api.post(this.$url.checkBillInfo.save, this.form)
            .then(res => {
              if (res) {
                this.form = {
                  name: '',
                  productBoList: [],
                  beginTime: '',
                  endTime: '',
                  checkType: ''
                };
                this.itemList = [];
                this.addEditShow = false;
                this.$message.success("保存成功");
                this.$emit("change", true);
              }
            })
            .catch(error => {});
      },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.contents-body {
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .tables-title {
    font-size: 14px;
    margin: 0 16px;
    padding: 10px 0;
    font-size: 16px;
    font-weight: 600;
    background: #f7f8fa;
  }
  .tables {
    padding: 0 16px 0;
    max-height: 150px;
    box-sizing: border-box;
    .boxs {
      min-height: 65px;
      padding: 24px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #ebedf0;
      .titles {
        font-weight: 500;
      }
      .money {
        color: @money;
        font-weight: 500;
      }
      .nums {
        /deep/.el-input-number {
          width: 80px;
          .el-input__inner {
            padding: 0 25px;
            height: 22px;
            line-height: 22px;
          }
        }
      }
      .delete {
        font-size: 18px;
        cursor: pointer;
        &:hover {
          color: @blue;
        }
      }
    }
    .right-content {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .staff-btn {
        display: inline-block;
        text-align: center;
        color: #111;
      }
    }
  }
}

.order-scoll {
  max-height: calc(100vh - 360px);
  overflow: auto;
}

.memberInfo {
  padding: 0 20px;
}
.pay-mains {
  padding: 0;
  overflow: hidden;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}

.iscompanyQuit {
  padding: 12px;
  margin: 0 10px;
  background: #E0F0FF;
  border-radius: 6px 6px 6px 6px;
  img {
    vertical-align: middle;
    margin-right: 5px;
  }
}

</style>